import SubjectHeader from '../../components/SubjectHeader/SubjectHeader';
import NoLiveSessions from '../../components/NoLiveSessions/NoLiveSessions';
import { useEffect, useState, SyntheticEvent } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLazyQuery, useMutation } from "@apollo/client";
import ToasterWithMessage from '../../components/toaster';
import CustomTab from '../CustomTab/CustomTab';
import { useAppSelector } from '../../redux/app/hooks';
import ConfirmationPopup from '../../components/ConfirmationPopup/ConfirmationPopup';
import images from "../../assets/images";
import './Assignments.scss';
import Loader from '../../components/Loader/Loader';
import { STUDENT_ROLE, TEACHER_ROLE } from '../../utils/constants';
import FileUpload from '../../components/Popups/FileUpload';
import UploadToaster from '../../components/Popups/UploadProgressBar/UploadProgressPopup';
import { DELETE_ASSIGNMENT, DELETE_SUBMITTED_ASSIGNMENTS, GET_ALL_SUBMITTED_ASSIGNMENTS, GET_ASSIGNMENTS, STUDENTS_LIST_FOR_ASSIGNMENTS, SUBMIT_ASSIGNMENT, UPDATE_ASSIGNMENT, UPDATE_SUBMITTED_ASSIGNMENTS, UPLOAD_ASSIGNMENT } from './api/AssignmentsQuery';
import AssignmentCard from './Components/AssignmentCard';
import PDFViewer from '../../components/PDFViewer/PDFViewer';
import CsvViewer from '../../components/CsvViewer/CsvViewer';
import FileViewer from '../../components/FileViewer/FileViewer';
import { READ_CLASSROOMUPDATES } from '../TeacherStudentClassroom/api/TeacherStudentClassroomQuery';
import { CONVERT_PPT_DOCS_TO_PDF } from '../TeacherTeachingMaterial/api/TeacherTeachingMaterialQuery';
import { checkFileStatusInDatabase } from '../../database';
import { getFileViewerType, getScreenDimensions } from '../../utils/helper';

export type Students = {
  studentAvatarUrl: string;
  studentId: string;
  studentName: string;
  totalScore: number;
}

export type assignment = {
  fileId: string;
  filename: string;
  filepath: string;
  filesize: number;
  filetype: string;
  isClassroom: boolean
  coverimagepath?: string;
  authorname?: string;
  feedId? : string
}

export type assignmentData = {
  datas: assignment[],
  totalCount: number
}

export type students = {
  studentId: string,
  studentName: string,
  studentAvatarUrl:string
}

export type studentsData = {
  nodes: students[],
  totalCount: number
}

const Assignments = () => {
  const { state } = useLocation();
  const [isUploadOpen, setIsUploadOpen] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [uploaded, setuploaded] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadFailed, setUploadFailed] = useState<boolean>(false);
  const [uploadFileName, setUploadFileName] = useState<string>('');
  const [url, setUrl] = useState<string>();
  const [filename, setFilename] = useState<string>();
  const [fileData, setFileData] = useState<File | null>();
  const baseUrl = process.env.REACT_APP_FRONTEND_URL;
  const [assignmentsData, setAssignmentsData] = useState<assignmentData>();
  const [submittedAssignmentsData, setSubmittedAssignmentsData] = useState<assignmentData>();
  const [studentsData, setStudentsData] = useState<studentsData>();
  const [activeTab, setActiveTab] = useState<number>(0);
  const [selectedAssignment, setSelectedAssignment] = useState<assignment>();
  const [selectedStudent, setSelectedStudent] = useState<students>();
  const selectedSubjectId = localStorage.getItem('selectedSId');
  const selectedClassRoomId = useAppSelector((state) => state.auth.selectedClassRoomId);
  const [openConfirmationPopup, setOpenConfirmationPopup] = useState<boolean>(false);
  const [action, setAction] = useState<string>('');
  const [refetch, setRefetch] = useState<boolean>(false);
  const [downloadRefetch, setDownloadRefetch] = useState<boolean>(false);
  const { success, error } = ToasterWithMessage();
  const { ShareGif, DeleteGif, docsImg, uploadCloud, assignmentUser } = images;
  const role = useAppSelector((state) => state.auth.role);
  const labels = ["Assignment", role === TEACHER_ROLE ? "Submitted Assignment":"Submit Assignment"];
  const navigate = useNavigate();
  const backNavigation = (role === STUDENT_ROLE) ? '/student-classroom' : '/teacher-classroom';
  const [subCategory, setSubCategory] = useState<string>();
  const [openPdf, setOpenPdf] = useState(false);
  const [openStudentAssignments, setOpenStudentAssignments] = useState(false);
  const profile = useAppSelector((state) => state.auth.adminProfile);
  const [fileExists, setFileExists] = useState<{ [key: string]: boolean| undefined }>({});

  const [getAllAssigments, { loading }] = useLazyQuery(GET_ASSIGNMENTS, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      setAssignmentsData(data?.getAllUploadedAssignments);
    },
    onError: (err) => {
      error(err?.message);
      if (err?.message === "Subject not found for teacher" || err?.message === "Subject not found") {
        setTimeout(() => {
          if (role === STUDENT_ROLE) {
            navigate('/student-classroom');
          } else {
            navigate('/teacher-classroom');
          }
        }, 2000);
      }
    }
  });

  const [getAllStudents, { loading: studentsLoading }] = useLazyQuery(STUDENTS_LIST_FOR_ASSIGNMENTS, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      setStudentsData(data?.getSubmittedAssignmentsWithStudentDetails);
    },
    onError: (err) => {
      error(err?.message);
      if (err?.message === "Subject not found for teacher" || err?.message === "Subject not found") {
        setTimeout(() => {
          if (role === STUDENT_ROLE) {
            navigate('/student-classroom');
          } else {
            navigate('/teacher-classroom');
          }
        }, 2000);
      }
    }
  });

  const [uploadAssignment] = useMutation(UPLOAD_ASSIGNMENT, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      if (data?.addAssignment) {
        setFileData(null);
        if (filename) {
          setUploadFileName(filename);
        }
        setuploaded(true);
        setUploadProgress(100);
        setFilename('');
        setUrl('');
        getAllAssigments({
          variables: {
            input: {
              cId: selectedClassRoomId,
              sjId: selectedSubjectId,
              searchInput: `%%`,
              limit: null,
              offset: null
            }
          }
        })
      }
    },
    onError: (err) => {
      if (filename) {
        setUploadFileName(filename);
      }
      setuploaded(true);
      setUploadProgress(0);
      setUploadFailed(true);
    }
  });

  const [submitAssignment] = useMutation(SUBMIT_ASSIGNMENT, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      if (data?.submitAssignment) {
        setFileData(null);
        if (filename) {
          setUploadFileName(filename);
        }
        setuploaded(true);
        setUploadProgress(100);
        setFilename('');
        setUrl('');
        getSubmittedAssignments({
          variables: {
            input: {
              cId: selectedClassRoomId,
              sjId: selectedSubjectId,
              searchInput: `%%`,
              limit: null,
              offset: null
            }
          }
        })
      }
    },
    onError: (err) => {
      if (filename) {
        setUploadFileName(filename);
      }
      setuploaded(true);
      setUploadProgress(0);
      setUploadFailed(true);
    }
  });

  const [getSubmittedAssignments, { loading: loadingResults }] = useLazyQuery(GET_ALL_SUBMITTED_ASSIGNMENTS, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      setSubmittedAssignmentsData(data?.getSubmittedAssignments);
      setDownloadRefetch(false);
    },
    onError: (err) => {
      error(err?.message);
      if (err?.message === "Subject not found for teacher" || err?.message === "Subject not found") {
        setTimeout(() => {
          if (role === STUDENT_ROLE) {
            navigate('/student-classroom');
          } else {
            navigate('/teacher-classroom');
          }
        }, 2000);
      }
    }
  });

  const [updateAssignment] = useMutation(UPDATE_ASSIGNMENT, {
    fetchPolicy: "no-cache",
    onCompleted: () => {
      setRefetch(!refetch);
      success(`${action === "share" ? "Shared" : "Unshared"} successfully`);
    },
    onError: (err) => {
      error(err?.message);
      if (err?.message === "Subject not found for teacher" || err?.message === "Subject not found") {
        setTimeout(() => {
          if (role === STUDENT_ROLE) {
            navigate('/student-classroom');
          } else {
            navigate('/teacher-classroom');
          }
        }, 2000);
      }
    }
  })

  const [deleteAssignment] = useMutation(DELETE_ASSIGNMENT, {
    fetchPolicy: "no-cache",
    onCompleted: () => {
      setRefetch(!refetch);
      success("Deleted successfully");
    },
    onError: (err) => {
      error(err?.message);
      if (err?.message === "Subject not found for teacher" || err?.message === "Subject not found") {
        setTimeout(() => {
          if (role === STUDENT_ROLE) {
            navigate('/student-classroom');
          } else {
            navigate('/teacher-classroom');
          }
        }, 2000);
      }
    }
  })

  const [updateSubmittedAssignment] = useMutation(UPDATE_SUBMITTED_ASSIGNMENTS, {
    fetchPolicy: "no-cache",
    onCompleted: () => {
      setRefetch(!refetch);
      success(`${action === "share" ? "Shared" : "Unshared"} successfully`);
    },
    onError: (err) => {
      error(err?.message);
      if (err?.message === "Subject not found for teacher" || err?.message === "Subject not found") {
        setTimeout(() => {
          if (role === STUDENT_ROLE) {
            navigate('/student-classroom');
          } else {
            navigate('/teacher-classroom');
          }
        }, 2000);
      }
    }
  })

  const [deleteSubmittedAssignment] = useMutation(DELETE_SUBMITTED_ASSIGNMENTS, {
    fetchPolicy: "no-cache",
    onCompleted: () => {
      setRefetch(!refetch);
      success("Deleted successfully");
    },
    onError: (err) => {
      error(err?.message);
      if (err?.message === "Subject not found for teacher" || err?.message === "Subject not found") {
        setTimeout(() => {
          if (role === STUDENT_ROLE) {
            navigate('/student-classroom');
          } else {
            navigate('/teacher-classroom');
          }
        }, 2000);
      }
    }
  });

  const checkFileExists = async (fileId: string) => {
    if (window.cordova) {
        try {
            const response = await checkFileStatusInDatabase(
                fileId,
                profile?.getCurrentUser?.nodes[0]?.uId,
                'Assignments'
            );
  
            console.log('File existence response:', response);
            if (response && response.success) {
                console.log(response,'=======file existance response');
                return response.exists;
            }
  
            console.error('Failed to check file existence:', response);
            return false;
        } catch (err) {
            console.error('Error checking file existence:', err);
            return false;
        }
    } else {
        console.warn("Cordova is not available");
        return false;
    }
  };
  
  const checkFiles = async (assignments: assignment[]) => {
    const updatedFileExists: Record<string, boolean| undefined> = {}; // Define the type here
    if (assignments && assignments.length > 0) {
        for (const assignment of assignments) {
            const exists = await checkFileExists(assignment.fileId);
            console.log('Inside the exists of checkFiles', exists);
            updatedFileExists[assignment.fileId] = exists; // Use the value from exists
        }
        setFileExists((prevState) => ({ ...prevState, ...updatedFileExists }));
    }
  };

  useEffect(() => {
    if (assignmentsData?.datas?.length) {
      checkFiles(assignmentsData.datas);
    }
  }, [assignmentsData]);
  
  useEffect(() => {
    if (submittedAssignmentsData?.datas?.length) {
      checkFiles(submittedAssignmentsData.datas);
    }
  }, [submittedAssignmentsData]);

  // Function to check if the file exists
const checkFileExistence = async (fileId: string): Promise<boolean|undefined> => {
  try {
      if(window.electron && window.electron.isElectron()){
      const response = await window.electron.checkFileStatus(fileId, profile?.getCurrentUser?.nodes[0]?.uId, 'Assignments');
      return response?.exists || false;
      }else{
        console.warn('Platform not supported');
      }
  } catch (error) {
      console.error('Error checking file existence:', error);
      return false;
  }
};

// Function to check all assignments' file status
const checkAllAssignmentsFileStatus = async (assignments: assignment[]) => {
  const updatedFileExists: Record<string, boolean| undefined> = {};
  for (const assignment of assignments) {
      const exists = await checkFileExistence(assignment.fileId);
      updatedFileExists[assignment.fileId] = exists;
  }
  // setFileExists(updatedFileExists);
  setFileExists((prevState) => ({ ...prevState, ...updatedFileExists })); // Use function form for setState

};

useEffect(() => {
  if (assignmentsData?.datas?.length) {
      checkAllAssignmentsFileStatus(assignmentsData.datas);
  }
}, [assignmentsData]);

useEffect(() => {
  if (submittedAssignmentsData?.datas?.length) {
      checkAllAssignmentsFileStatus(submittedAssignmentsData.datas);
  }
}, [submittedAssignmentsData]);


  const handleAssignmentActions = (selectedAssignment: assignment, action: string) => {
    if (selectedAssignment) {
      if (action === "delete") {
        if (role === TEACHER_ROLE) {
          deleteAssignment({
            variables: {
              cId: selectedClassRoomId,
              sjId: selectedSubjectId,
              fId: selectedAssignment?.fileId,
            }
          });
        } else if (role === STUDENT_ROLE) {
          deleteSubmittedAssignment({
            variables: {
              cId: selectedClassRoomId,
              sjId: selectedSubjectId,
              fId: selectedAssignment?.fileId,
            }
          });
        }
      }
      else if (action === "share" || action === "unshare") {
        if (role === TEACHER_ROLE) {
          updateAssignment({
            variables: {
              cId: selectedClassRoomId,
              sjId: selectedSubjectId,
              fId: selectedAssignment?.fileId,
              isClassroom: !selectedAssignment?.isClassroom
            }
          });
        } else if (role === STUDENT_ROLE) {
          updateSubmittedAssignment({
            variables: {
              cId: selectedClassRoomId,
              sjId: selectedSubjectId,
              fId: selectedAssignment?.fileId,
              isClassroom: !selectedAssignment?.isClassroom
            }
          });
        }
      }
    }
  }

  const onYesButtonClick = () => {
    setOpenConfirmationPopup(false);
    if (selectedAssignment)
      handleAssignmentActions(selectedAssignment, action)
  }

  const onNoButtonClick = () => {
    setOpenConfirmationPopup(false);
  }

  const handleChangeTab = (_e: SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
    setOpenPdf(false);
    setSubCategory('');
  };

  const handleClick = (action: string, assignment: any) => {
    setAction(action);
    if (action === "unshare") {
      handleAssignmentActions(assignment, action)
    }
    else {
      setOpenConfirmationPopup(true);
    }
    setSelectedAssignment(assignment);
  }

  const handleClickCard = (item: assignment) => {
    setSelectedAssignment(item);
    setOpenPdf(true);
  }
  const handleClickStudent = (item: students) => {
    setSubCategory(item?.studentName);
    setSelectedStudent(item);
    setOpenStudentAssignments(true);
  }

  useEffect(() => {
    setSubCategory('');
    setRefetch(!refetch);
  }, [state]);

  useEffect(() => {
    if ((openStudentAssignments === true || downloadRefetch === true)&& selectedStudent) {
      getSubmittedAssignments({
        variables: {
          input: {
            cId: selectedClassRoomId,
            sjId: selectedSubjectId,
            sId: selectedStudent?.studentId,
            searchInput: `%%`,
            limit: null,
            offset: null
          }
        }
      });
    }
  }, [downloadRefetch,openStudentAssignments]);
  
  
  useEffect(() => {
    // setAssignmentsData(undefined);
    // setStudentsData(undefined);
    setOpenStudentAssignments(false);
    if (selectedClassRoomId && selectedSubjectId) {
      if (activeTab === 0) {
        getAllAssigments({
          variables: {
            input: {
              cId: selectedClassRoomId,
              sjId: selectedSubjectId,
              searchInput: `%%`,
              limit: null,
              offset: null
            }
          }
        });
      }
      else {
        if (role === STUDENT_ROLE) {
          getSubmittedAssignments({
            variables: {
              input: {
                cId: selectedClassRoomId,
                sjId: selectedSubjectId,
                // sId: selectedStudentId,
                searchInput: `%%`,
                limit: null,
                offset: null
              }
            }
          });
        } else if (role === TEACHER_ROLE) {
          getAllStudents({
            variables: {
              cId: selectedClassRoomId,
              sjId: selectedSubjectId,
              // searchInput: `%%`,
              limit: null,
              offset: null
            }
          });
        }
      }
    }
  }, [activeTab, refetch]);



  const [readAssignmentFeed] = useMutation(READ_CLASSROOMUPDATES, {
    fetchPolicy: 'network-only',
    onCompleted : (data) =>{
    },
    onError: (err) =>{
      console.log(err.message)
    }
  })

  const [convertPptDocToPdf, { loading: convertLoading }] = useLazyQuery(CONVERT_PPT_DOCS_TO_PDF, {
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
        console.log('CONVERT_PPT_DOCS_TO_PDF response========>',data);
    },
    onError: (err) => {
      error(err?.message);
      // setuploaded(true);
      // setUploadProgress(0);
      // setUploadFailed(true);
      if (err?.message === "Subject not found for teacher" || err?.message === "Subject not found") {
        setTimeout(() => {
          if (role === STUDENT_ROLE) {
            navigate('/student-classroom');
          } else {
            navigate('/teacher-classroom');
          }
        }, 2000);
      }
    }
});

  useEffect(()=>{
  if(role === STUDENT_ROLE){
  if(assignmentsData?.datas?.length && assignmentsData?.datas?.length > 0){
    assignmentsData?.datas.forEach((data) => {
      if (data.feedId) {
        readAssignmentFeed({
          variables: {
            fId: data.feedId,
            uId: profile?.getCurrentUser?.nodes[0]?.uId
          }
        })
      }
    });
  }
}
  },[assignmentsData, profile?.getCurrentUser?.nodes, readAssignmentFeed, role])

  useEffect(() => {
    if (fileData && filename && filename !== '' && url) {
        const parts = url.split('.');
        const extension = parts.length > 1 ? parts.pop() : undefined;
        const uploadVariablesForTeacher = {
            filename: filename?.replace(/\.pdf$/, "")?.trim(),
            filepath: url,
            filesize: fileData?.size,
            filetype: fileData?.type === "application/pdf" ? "pdf" : fileData?.type === "text/csv" ? "csv" : fileData?.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ? "xlsx" : fileData?.type === "application/vnd.ms-excel" ? "xls" : fileData?.type === "application/vnd.ms-powerpoint" ? "ppt" : fileData?.type === "application/vnd.openxmlformats-officedocument.presentationml.presentation" ? "pptx" : fileData?.type === "application/msword" ? "doc" : fileData?.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ? "docx" : null,
            isClassRoom: false,
            sjId: selectedSubjectId,
            cId: selectedClassRoomId,
        }
        const uploadVariablesForStudent = {
          filename: filename?.replace(/\.pdf$/, "")?.trim(),
          filepath: url,
          filesize: fileData?.size,
          filetype: fileData?.type === "application/pdf" ? "pdf" : fileData?.type === "text/csv" ? "csv" : fileData?.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ? "xlsx" : fileData?.type === "application/vnd.ms-excel" ? "xls" : fileData?.type === "application/vnd.ms-powerpoint" ? "ppt" : fileData?.type === "application/vnd.openxmlformats-officedocument.presentationml.presentation" ? "pptx" : fileData?.type === "application/msword" ? "doc" : fileData?.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ? "docx" : null,
          isClassroom: false,
          sjId: selectedSubjectId,
          cId: selectedClassRoomId,
        };

        if (extension && ['doc', 'docx', 'ppt', 'pptx'].includes(extension.toLowerCase())) {
            // Convert documents or PowerPoint files to PDF
            convertPptDocToPdf({
                variables: {
                    key: url
                }
            })
            .catch(error => {
                console.error("Error during conversion or upload:", error);
            });
            if (role === TEACHER_ROLE) {
                uploadAssignment({
                    variables: uploadVariablesForTeacher,
                });
            } else {
                submitAssignment({
                    variables: {
                        input: uploadVariablesForStudent,
                    }
                });
            }
        } else {
            // Directly upload if no conversion is needed
            if (role === TEACHER_ROLE) {
                uploadAssignment({
                    variables: uploadVariablesForTeacher,
                });
            } else {
                submitAssignment({
                    variables: {
                        input: uploadVariablesForStudent,
                    }
                });
            }
        }
    }
}, [fileData, filename, url, role, selectedSubjectId, selectedClassRoomId]);


  //To open upload popup
  const handleOpenUploadAssignment = () => {
    setIsUploadOpen(true);
    setOpen(true);
  };

  //To close pdf detailed view
  const handleClosePdf = () => {
    if(role === TEACHER_ROLE && openStudentAssignments && activeTab === 1 && !openPdf){
      setOpenPdf(false);
      setOpenStudentAssignments(false);
      setSubCategory('');
      setSelectedAssignment(undefined);
      setSelectedStudent(undefined);
      setRefetch(true);
    }else{
    setOpenPdf(false);
    setSelectedAssignment(undefined);
    setRefetch(true);
    }
  }

  return (
    <div className='assignmentMainContainer'>
      <div className='assignmentHeader'>
        <SubjectHeader
          headerName={state?.title}
          backgroundColor={state?.backGroundColor}
          subCategory={subCategory}
          headerImage={state?.imageSrc}
          backNavigation={{ path: backNavigation, state: state }}
          tabName={activeTab === 1 ? 'Submitted  Assignment':'Assignments'}
          openPdf={openPdf}
          onClose={handleClosePdf}
          openStudentAssignments={openStudentAssignments}
        />
        <div className='assignmentTabContainer'>
          <CustomTab activeTab={activeTab} handleChangeTab={handleChangeTab} labels={labels} />
         { !getScreenDimensions().isMobileScreen &&<div className={(((role === TEACHER_ROLE && activeTab === 0) || (role === STUDENT_ROLE && activeTab === 1 && assignmentsData && assignmentsData?.totalCount > 0)) && !openPdf) ? 'assignmentHeaderUpload' : 'uploadHide'} onClick={(((role === TEACHER_ROLE && activeTab === 0) || (role === STUDENT_ROLE && activeTab === 1 && assignmentsData && assignmentsData?.totalCount > 0)) && !openPdf) ? handleOpenUploadAssignment : undefined}>
            <img src={uploadCloud} alt="upload" className='uploadImage' />
          </div>}
        </div>
      </div>
      {(loading || loadingResults || studentsLoading) ? (
        <Loader bottom="110px" />
      ) : (
        <>
          {openPdf ? ( selectedAssignment?.filetype === "pdf" ? 
            <div className='DetailedView'>  
              <PDFViewer
                file={selectedAssignment?.filepath ? baseUrl + selectedAssignment?.filepath : ''}
                pdfFileData={selectedAssignment}
                onClose={handleClosePdf}
                type="Assignment"
              />
            </div>
            // : selectedAssignment?.filetype === "csv" ? 
            //   <div className='excelOuterContainer'>
            //     <CsvViewer
            //       fileUrl={selectedAssignment?.filepath ? baseUrl + selectedAssignment?.filepath : ''}
            //       fileData={selectedAssignment}
            //       onClose={handleClosePdf}
            //     /> 
            //   </div>
            : (selectedAssignment?.filetype === "doc" || selectedAssignment?.filetype === "docx" || selectedAssignment?.filetype === "ppt" || selectedAssignment?.filetype === "pptx" || selectedAssignment?.filetype === "xls" || selectedAssignment?.filetype === "xlsx") ?
              <div className='excelOuterContainer'>
                <FileViewer fileUrl={selectedAssignment?.filepath ? baseUrl + selectedAssignment?.filepath : ''} fileData={selectedAssignment} onClose={handleClosePdf} fileType={getFileViewerType(selectedAssignment?.filetype)}/>
              </div>
            : (selectedAssignment?.filetype === "csv" ) ?
            <div className='excelOuterContainer'>
              <CsvViewer fileUrl={selectedAssignment?.filepath ? baseUrl + selectedAssignment?.filepath : ''} fileData={selectedAssignment} onClose={handleClosePdf} />
            </div>
            : <></>
            ) : (
            <>
              {/* {(assignmentsData?.totalCount === 0 || studentsData?.totalCount === 0 || submittedAssignmentsData?.totalCount === 0) && <NoLiveSessions tabName="Assignment" />} */}
              {activeTab === 0 ? (
                (assignmentsData && assignmentsData?.totalCount > 0 && !openPdf) ? (
                   <div className="assignmentCardContainer">
                    {assignmentsData?.datas.map((item) => (
                      <AssignmentCard
                        key={item?.fileId}
                        image={docsImg}
                        subject={state?.title}
                        subCategory={'Assignments'}
                        data={item}
                        fileExists={fileExists[item?.fileId]}
                        reload={()=>setRefetch(!refetch)}
                        tabName={'Assignment'}
                        handleClickShareDelete={handleClick}
                        handleClickCard={handleClickCard}
                      />
                    ))}
                  </div>
                )
                :(
                  <NoLiveSessions tabName="Assignment" />
                )
              ) : (
                (role === TEACHER_ROLE && !openStudentAssignments) ? (
                  (studentsData && studentsData?.totalCount > 0 && !openPdf ) ? (
                    <div className="studentCardContainer">
                      {studentsData?.nodes.map((item) => (
                        <div className='studentCard' key={item?.studentId} onClick={() => handleClickStudent(item)}>
                          <div className="studentImageCtn">
                            <img src={item?.studentAvatarUrl ? baseUrl + item?.studentAvatarUrl : assignmentUser} alt="studentImage" className="studentImg" />
                          </div>
                          <div className="studentName">{item?.studentName}</div>
                        </div>
                      ))}
                    </div>
                  ):(
                    <NoLiveSessions tabName="Assignment" />
                  )
                ) : (
                  (submittedAssignmentsData && submittedAssignmentsData?.totalCount > 0 && !openPdf ) ? (
                    <div className="assignmentCardContainer">
                      {submittedAssignmentsData?.datas.map((item) => (
                        <AssignmentCard
                          key={item?.fileId}
                          image={docsImg}
                          data={item}
                          subject={state?.title}
                          fileExists={fileExists[item?.fileId]}
                          reload={()=>setDownloadRefetch(true)}
                          tabName={'Submitted  Assignment'}
                          handleClickShareDelete={handleClick}
                          handleClickCard={handleClickCard}
                        />
                      ))}
                    </div>
                  ):(
                    <NoLiveSessions tabName="Assignment" />
                  )
                )
              )}
            </>
          )}
           { getScreenDimensions().isMobileScreen && <div className={(((role === TEACHER_ROLE && activeTab === 0) || (role === STUDENT_ROLE && activeTab === 1 && assignmentsData && assignmentsData?.totalCount > 0)) && !openPdf) ? `assignmentHeaderUpload ${getScreenDimensions().isMobileScreen?'mobileassignmentHeaderUpload':'' }` : 'uploadHide'} onClick={(((role === TEACHER_ROLE && activeTab === 0) || (role === STUDENT_ROLE && activeTab === 1 && assignmentsData && assignmentsData?.totalCount > 0)) && !openPdf) ? handleOpenUploadAssignment : undefined}>
           <div className='upload'> <img src={uploadCloud} alt="upload" className='uploadImage' /></div>
          </div>}
        </>
        
      )}
      
      {isUploadOpen && <FileUpload type='assignment' name="Assignment" setUrl={setUrl} open={open} setOpen={setOpen} setIsUploadOpen={setIsUploadOpen} folderName="materials" setFilename={setFilename} setFileData={setFileData} setUploadFailed={setUploadFailed} setUploadProgress={setUploadProgress} setuploaded={setuploaded} setUploadFileName={setUploadFileName} />}
      {uploaded && <UploadToaster uploaded={uploaded} setuploaded={setuploaded} uploadProgress={uploadProgress} setUploadProgress={setUploadProgress} fileName={uploadFileName} setUploadFileName={setUploadFileName} uploadFailed={uploadFailed} setUploadFailed={setUploadFailed} />}
      <ConfirmationPopup
        open={openConfirmationPopup}
        message={action === "share" ? `Are you sure you want to Share this file with your Classroom?` : `Are you sure you want to Delete this file from the Classroom?`}
        gifData={action === "share" ? ShareGif : DeleteGif}
        yesButtonFunctionality={onYesButtonClick}
        noButtonFunctionality={onNoButtonClick}
        messageWidth={'195px'}
      />
    </div>
  )
}

export default Assignments;
